import { di } from 'react-magnetic-di';
import { fireErrorAnalytics } from '@atlassian/ui-modifications-analytics';
import { getSupportedFieldConfiguration } from '../../../view-configuration';
export var mapFieldValueFromInternalToPublic = function mapFieldValueFromInternalToPublic(_ref) {
  var fieldMetadata = _ref.fieldMetadata,
    internalFieldValue = _ref.internalFieldValue,
    fieldType = _ref.fieldType,
    viewType = _ref.viewType;
  if (fieldMetadata === undefined) {
    throw new Error('Attempt to set value for the uninitialized field');
  }
  var value = internalFieldValue;
  try {
    var _getSupportedFieldCon;
    var valueTransformer = (_getSupportedFieldCon = getSupportedFieldConfiguration(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.internalToPublicTransformers.value;
    if (valueTransformer) {
      /**
       * We trust that the internal field data is in the correct shape.
       * Data that is in the incorrect shape will result in error events
       * being logged for further investigation. In this error case we will
       * pass `null` as the value to unblock onInit for the apps
       *
       * The `fieldRenderer` passed to the `valueTransformer` is used only for
       * rich text fields and will be `undefined` for most of the executions
       */
      value = valueTransformer(internalFieldValue, fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.fieldRenderer);
    }
  } catch (error) {
    value = null;
    fireErrorAnalytics({
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      error: error,
      id: 'internalToPublicValueTransformer',
      viewType: viewType,
      attributes: {
        fieldType: fieldType
      }
    });
  }
  return value;
};